import { useEffect } from "react";
import PodcastEpisodesTabContentManagementPanel from "@/components/discovery/discovery-content-control-panels/PodcastEpisodesTabContentManagementPanel";
import PodcastEpisodesTable from "@/components/discovery/podcast-episodes-table/PodcastEpisodesTable";
import useDiscoveryContentManagementStore from "@/store/discovery/discovery-content-management/discovery-content-management.slice";

const PodcastEpisodesTab = () => {
  useEffect(() => {
    return () => {
      const { resetPodcastEpisodesTableState, setPodcastEpisodesSearchTerm } =
        useDiscoveryContentManagementStore.getState();
      resetPodcastEpisodesTableState();
      setPodcastEpisodesSearchTerm("");
    };
  }, []);

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <PodcastEpisodesTabContentManagementPanel />
      <div className="min-h-0 flex-1">
        <PodcastEpisodesTable />
      </div>
    </div>
  );
};

export default PodcastEpisodesTab;
